import React from 'react';
import PropTypes from 'prop-types';

import CommonActionCallout from 'dpl/prismic/components/ActionCallout';

export default function ActionCallout({ sliceData }) {
  return (
    <div className="PrismicHubActionCallout container">
      <CommonActionCallout sliceData={sliceData} />
    </div>
  );
}
ActionCallout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  sliceData: PropTypes.object.isRequired
};
